import { render, staticRenderFns } from "./SenderBans.vue?vue&type=template&id=bd9d37bc&"
import script from "./SenderBans.vue?vue&type=script&lang=ts&"
export * from "./SenderBans.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports